<template>
    <div>
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="modal" :data-target="'#requestModal' + this.row.id">
            <i class="fa fa-cog"></i>
        </button>

        <!-- Modal -->
        <div class="modal fade" :id="'requestModal' + this.row.id" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ $t('stakeholders.label.change_stakeholders_request') }} ({{ this.row.gateway_title }})</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-bordered">
                            <tr>
                                <td v-text="$t('label.id')"></td>
                                <td v-text="$t('label.full_name')"></td>
                                <td v-text="$t('label.previous_status')"></td>
                                <td v-text="$t('label.details')"></td>
                            </tr>
                            <tr v-for="(item, index) in this.row.description.stakeholders" :key="index">
                                <td v-text="item.id"></td>
                                <td v-text="item.full_name"></td>
                                <td>
                                    <span :class="'badge badge-' + stakeholder_variant(item.status)" v-text="stakeholder_status_str.get(item.status)"></span>
                                </td>
                                <td>
                                    <a :href="`/stakeholders/update/${item.id}`" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                        <i class="fas fa-info-circle"></i>
                                    </a>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="modal-footer mx-auto">
                        <button
                                type="button"
                                class="btn btn-danger"
                                :id="'reject_btn' + this.row.id"
                                data-dismiss="modal"
                                @click="changeRequestStatus(shRequestStatus.FINAL_REJECT, 'reject_btn')"
                        >
                            {{ $t('btn.reject_request') }}
                        </button>
                        <button
                                type="button"
                                class="btn btn-primary"
                                :id="'confirm_btn' + this.row.id"
                                data-dismiss="modal"
                                @click="changeRequestStatus(shRequestStatus.PENDING, 'confirm_btn')"
                        >
                            {{ $t('btn.confirm_request') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import $ from 'jquery';
    import { i18n } from '@/plugins/i18n';
    import { shRequestStatus } from '@/constants/shaparakRequestStatus';
    import { shaparakService } from "@/common/api.service";
    import toastr from "toastr";
    import { KTApp } from '@/plugins/core/app';
    import { stakeholderStatusStr, stakeholderVariant } from '@/constants/stakeholderStatus';

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            },
            store: {
                required: true
            },
        },
        data() {
            return {
                shRequestStatus: shRequestStatus,
                stakeholder_status_str: stakeholderStatusStr,
                stakeholder_variant: stakeholderVariant,
            }
        },
        computed: {
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            },
        },
        methods: {
            changeRequestStatus(status, btn_id) {
                let btn = $('#' + btn_id + this.row.id);

                KTApp.progress(btn)

                let params = {
                    status: status,
                    hashid: this.row.id,
                }

                shaparakService.changeStakeholdersRequestStatus(params).then(response => {
                    this.toastr.success(response.data.message);
                    KTApp.unprogress(btn);
                    $('#requestModal' + this.row.id).modal('toggle');
                    this.datatable.reload();
                    this.store.dispatch('badgeCounter/countData');
                }).catch(({response}) => {
                    this.toastr.fail();
                    KTApp.unprogress(btn);
                })
            }
        }
    })
</script>
